import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { IKImage } from 'imagekitio-react';
import { useSelector } from 'react-redux';

const SearchResultsDropdown = ({ results, isEmpty, setSearchString, noSearch}) => {
    const { skills, mskills ,personalized_courses  } = results;
    const email = useSelector(store => store?.profileDetails?.email);
    const noResultFeatures = ['Personalised Syllabus' , 'Practical Projects' , 'Industry Certification' , 'Lifetime Access']
    console.log('rr' , noSearch);
    if (!isEmpty) {
        return (
            <ul className="absolute w-[85%]  h-fit md:w-full p-1 top-10 z-50 shadow-xl bg-white list-none rounded">
                {
                   personalized_courses?.filter((item, idx) => idx <= 5).map((personalize_item, idx) => (
                       <Link to={''} replace key={idx} onClick={()=> {setSearchString(''); window.open(`https://personalise.learntube.ai/welcome?email=${email}&skill_name=${encodeURIComponent(personalize_item["skill_name"])}&utm_source=webapp-navbar&utm_medium=search-result`,'_blank'); }}>
                           <li className='flex gap-2 justify-start items-center rounded px-1 py-2 cursor-pointer md:hover:bg-teal-600 md:hover:text-white md:hover:font-bold'>
                               <FontAwesomeIcon icon={faSearch} />
                               <span className='text-xs md:text-sm truncate'>{personalize_item["skill_name"]}</span>
                               <span className="w-18 text-supertiny flex justify-center items-center rounded-full border-2 border-[#1F90CF] md:hover:text-white font-bold p-1.5 text-center"><img
                                urlEndpoint="https://assets.learntube.ai/files/"
                                src={
                                    "https://assets.learntube.ai/files/Learntube/Group%2010100.svg?updatedAt=1705835753580"
                                }
                                className="w-[18px] h-[18px] mr-1"
                                />Personalised Course</span>
                           </li>
                       </Link>
                   ))
               }
                {
                    skills.filter((item, idx) => idx <= 5).map((skill_item, idx) => (
                        <Link key={idx} to={`/${skill_item["course_slug"]}/${skill_item["skill_slug"]}`} onClick={()=> setSearchString('')} replace>
                            <li className='flex gap-2 justify-start items-center rounded px-1 py-2 cursor-pointer md:hover:bg-teal-600 md:hover:text-white md:hover:font-bold' >
                                <FontAwesomeIcon icon={faSearch} />
                                <span className='text-xs md:text-sm'>{skill_item["skill-name"]}</span>
                                <span className="w-12 text-supertiny rounded-full border-2 border-orange-500 md:hover:text-white font-bold p-1.5 text-center">Skill</span>
                            </li>
                        </Link>
                    ))
                }
                {
                    mskills.filter((item, idx) => idx <= 5).map((mskill_item, idx) => (
                        <Link to={`/${mskill_item["course_slug"]}/${mskill_item["skill_slug"]}/${mskill_item.mskill_slug}/${mskill_item.first_lesson?.id}`} replace key={idx} onClick={()=> {setSearchString('');}}>
                            <li className='flex gap-2 justify-start items-center rounded px-1 py-2 cursor-pointer md:hover:bg-teal-600 md:hover:text-white md:hover:font-bold'>
                                <FontAwesomeIcon icon={faSearch} />
                                <span className='text-xs md:text-sm truncate'>{mskill_item["mSkill-name"]}</span>
                                <span className="w-18 text-supertiny rounded-full border-2 border-teal-500 md:hover:text-white font-bold p-1.5 text-center">Micro-skill</span>
                            </li>
                        </Link>
                    ))
                }
            </ul>);
    } else {
        return (
            <ul className='absolute w-[95%] h-fit p-1 top-10  z-50 shadow-xl bg-white list-none rounded-xl'>
                <li className='flex flex-col justify-center items-center rounded px-2 py-2 '>
                    <span className='text-[14px] md:text-[16px] font-medium'>No matches found</span>
                    <div className='bg-[#D4F4FF] rounded-xl p-2  w-full flex flex-col justify-center items-center mt-4'>
                        <div className='font-medium text-[20px] md:text-[24px] flex justify-center items-center md:justify-center md:items-center '>
                        {window?.innerWidth < 768 && <img
                                urlEndpoint="https://assets.learntube.ai/files/"
                                src={
                                    "https://assets.learntube.ai/files/Learntube/Group%2010118.svg?updatedAt=1706772449470"
                                }
                                className="h-full w-[20%] mr-4"
                                />}
                            <span className='leading-tight'>Create Personalised Course For<span className='text-[#1F90CF] ml-1 font-bold'>{noSearch}</span></span> </div>
                        <div className='flex justify-between items-center px-1 md:px-8 mt-4 w-full md:w-[95%]'>
                            {window?.innerWidth>= 768 && <img
                                urlEndpoint="https://assets.learntube.ai/files/"
                                src={
                                    "https://assets.learntube.ai/files/Learntube/Group%2010118.svg?updatedAt=1706772449470"
                                }
                                className="h-full"
                                />}
                            <div className='bg-[#B3EBFF] rounded-xl  py-4 px-2 md:px-8'>
                                <div className='text-[#12546B] text-[16px] font-semibold'>What’s Included:</div>
                                <div className='grid grid-rows-2 grid-cols-2 gap-3 md:gap-2 mt-2'>
                                    {noResultFeatures?.map((item,index)=><div className='flex justify-start items-center'>
                                        <img
                                                urlEndpoint="https://assets.learntube.ai/files/"
                                                src={
                                                    "https://assets.learntube.ai/files/Learntube/Group%2010120.svg?updatedAt=1706773166935"
                                            }
                                                className="mr-1 md:mr-2"
                                            />
                                        <div className='font-medium whitespace-nowrap text-[12px] md:text-[14px] text-[#1A6D8A] font-montserrat'>{item}</div>
                                    </div>)}
                                </div>
                            </div>
                        </div>
                        <div className='flex justify-between items-center px-2 md:px-8 mt-6 w-full md:w-[95%]'>
                            <div className='flex justify-center items-center'><img
                                urlEndpoint="https://assets.learntube.ai/files/"
                                src={
                                    "https://assets.learntube.ai/files/Learntube/Group%2010100.svg?updatedAt=1705835753580"
                                }
                                className="w-[18px] h-[18px] mr-1"
                                />
                                <div className='text-[12px] md:text-[14px] font-semibold text-[#1F90CF]'>LearnTubeX Feature</div>
                                </div>
                            <button className='bg-[#13B284] cursor-pointer text-white text-[12px] md:text-[14px] rounded-lg py-2 px-6 md:px-10 font-semibold'  onClick={(e)=> window.open(`https://personalise.learntube.ai?skill_slug=${noSearch}&utm_source=webapp-navbar&utm_medium=search-result`)}>Personalise Now!</button>
                        </div>
                    </div>
                </li>
                
            </ul>
        )
    }
}

export default SearchResultsDropdown;